<template>
  <section class="card">
    <h2 class="section-heading">
      {{ t('employerForm.centralizedInsuranceViewConsent.title') }}
    </h2>

    <div class="acknowledgement-wrapper">
      <label :class="['checkbox-item',{'is-invalid':formErrors.has('centralizedInsuranceViewConsent.accepted')}]">
        <!-- <input
          type="checkbox"
          v-model="form.accepted"
          @change="clearError('centralizedInsuranceViewConsent.accepted')"
        /> -->

        <span class="policy-text">
          {{ t('employerForm.centralizedInsuranceViewConsent.description') }}
        </span>
      </label>
      <!-- <p
        class="invalid-feedback"
        v-if="formErrors.has('centralizedInsuranceViewConsent.accepted')"
      >
        {{ t(formErrors.first('centralizedInsuranceViewConsent.accepted')) }}
      </p> -->
    </div>
  </section>
</template>

<script setup>
import Error from '@/utils/Error';
import { reactive, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({
      accepted:true
    })
  },

  formErrors: {
    type: Object,
    required: false,
    default: reactive(new Error({}))
  }
});

const emit = defineEmits([
  'update:modelValue',
  'removeError'
]);

const form = reactive({
  accepted: false,
  ...props.modelValue
});

watch(
  form,
  (val) => emit('update:modelValue', val),
  { deep: true }
);

watch(
  () => props.modelValue,
  (newValue) => {
    Object.assign(form, {
      accepted: false,
      ...newValue
    });
  },
  { deep: true, immediate: true }
);

// const clearError = (name) => {
//   emit('removeError', name);
// };
</script>

<style scoped>
.acknowledgement-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 10px 14px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
}

.acknowledgement-text {
  line-height: 1.7;
  color: #374151;
}

.checkbox-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  line-height: 1.5;
}
.policy-text {
  white-space: pre-line;
}
.acknowledgement-wrapper input[type="checkbox"]{
  width: 20px;
  height: 20px;
  min-width: 20px;
  margin-top: 2px; 
  cursor: pointer;
}
</style>